import {
    PerFilterState,
    initialFilterState,
    initialState,
} from "@/mk2/apps/bazaar/reducers/navigation";
import { AppState } from "@/mk2/reducers";

export const getBazaarNavigationState = (state: AppState): PerFilterState => {
    const s = state.containers.bazaar.navigation || initialState;
    return s.filters[s.active] || initialFilterState;
};
